var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingSafeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon parking safe",
    viewBox: "0 0 16 16.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17544 16h-10a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h.5V4.5a4.5 4.5 0 1 1 9 0V6h.5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-6.639-8.279a1.026 1.026 0 0 0-1.023 1.026v4.707a.817.817 0 1 0 1.635 0v-.819h1.229a2.459 2.459 0 0 0 2.457-2.457 2.43 2.43 0 0 0-2.457-2.457zM17539 2a2.5 2.5 0 0 0-2.5 2.5V6h5V4.5a2.5 2.5 0 0 0-2.5-2.5zm.2 9h-1.229V9.362h1.229a.819.819 0 0 1 0 1.638z",
    fill: "currentColor",
    transform: "translate(-17531)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSafeIcon);
export default __webpack_public_path__ + "static/media/parking-safe-icon.930818bc0639add7c27220aeee85ff59.svg";
export { ForwardRef as ReactComponent };